<script setup>
</script>

<template>
    <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M17.334 29.3334L26.055 20.6124C26.4455 20.2219 26.4455 19.5887 26.055 19.1982L17.334 10.4772"
            stroke="white"
            stroke-width="3"
            stroke-linecap="round"
        />
    </svg>
</template>
